<template>
  <div>
    <v-select :options="selectOptions" v-model="selectedOptions" multiple :searchable="false"/>
    <input type="hidden" :name="name" v-for="selectedOption in selectedOptions" :value="selectedOption.value">
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType, ref} from 'vue';
import vSelect from 'vue-select';

interface SelectOption {
    label: string;
    value: string;
}

export default defineComponent({
    components: {vSelect},
    props: {
        name: {
            type: String,
            required: true,
        },
        options: {
            type: Object as PropType<{[value: string]: string}>,
            required: true,
        },
        values: {
            type: Array as PropType<string[]>,
            required: true,
        },
    },
    setup(props) {
        const selectOptions = computed(() => {
            return Object.entries(props.options).map(([key, value]) => ({label: value, value: key}));
        });

        const selectedOptions = ref<SelectOption[]>(
            selectOptions.value.filter((option) => props.values.includes(option.value)),
        );

        return {selectOptions, selectedOptions};
    },
});
</script>
